import React, { useEffect, useState, createContext, useContext, useMemo } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const SettingsCtx = createContext({ settings: {}, refresh: () => {}, wishlinkLogoUrl: null });

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState({});
  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data.settings || {});
    } catch (e) {
      console.error("[settings] failed to load workspace settings", e);
    }
  };
  // Re-fetch on initial mount AND whenever the auth user changes (login/logout).
  // This guarantees brand users see workspace branding the moment they sign in.
  useEffect(() => { refresh(); }, [user?.email]);

  // Resolve the canonical cropped + background-stripped Wishlink logo URL.
  // The backend serves a tightly-cropped, transparent PNG at this path; bust the
  // cache whenever the saved logo changes by appending its size as a cache key.
  const wishlinkLogoUrl = useMemo(() => {
    if (!settings?.wishlink_logo_url) return null;
    const v = settings.wishlink_logo_size || settings.updated_at || "1";
    return `${BACKEND_URL}/api/notify/assets/wishlink-logo?v=${encodeURIComponent(v)}`;
  }, [settings?.wishlink_logo_url, settings?.wishlink_logo_size, settings?.updated_at]);

  return <SettingsCtx.Provider value={{ settings, refresh, wishlinkLogoUrl }}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
